import React from 'react';

const Pagination = ({ total, limit, page, onPageChange }) => {
  const totalPages = Math.ceil(total / limit);
  

  const getVisiblePages = () => {
    const visiblePages = [];
    const maxVisible = 5;
    let startPage = Math.max(1, page - 2);
    let endPage = Math.min(totalPages, startPage + maxVisible - 1);

    if (endPage - startPage + 1 < maxVisible) {
      startPage = Math.max(1, endPage - maxVisible + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      visiblePages.push(i);
    }
    return visiblePages;
  };

  return (
    <div className="pagination-panel px-0 py-4 d-flex justify-content-between align-items-center">
      <nav aria-label="Page navigation">
        <ul className="pagination mb-0 py-2">
          <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => onPageChange(page - 1)}
              disabled={page === 1}
            >
              Previous
            </button>
          </li>

          {getVisiblePages().map((pageNum) => (
            <li key={pageNum} className={`page-item ${page === pageNum ? 'active' : ''}`}>
              <button
                className="page-link"
                onClick={() => onPageChange(pageNum)}
              >
                {pageNum}
              </button>
            </li>
          ))}

          <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => onPageChange(page + 1)}
              disabled={page === totalPages}
            >
              Next
            </button>
          </li>
        </ul>
      </nav>

      <div className="pagination-info py-2">
        Showing {(page - 1) * limit + 1}–{Math.min(page * limit, total)} of {total} items
      </div>
    </div>
  );
};

export default Pagination;
